import { OutlinedInput } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';

import styles from './InputField.module.scss';

const inputStyle = {
  minWidth: 300,
  height: 30,
  fontSize: '13px !important',
  bgcolor: '#ffffff',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& .MuiOutlinedInput-input.Mui-disabled': {
    WebkitTextFillColor: '#000000',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#CECECE',
  },
  '& .Mui-disabled': {
    backgroundColor: '#ECEFF1',
  },
};

const smallInputStyle = {
  minWidth: 200,
  height: 30,
  fontSize: '13px !important',
  bgcolor: '#ffffff',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& .MuiOutlinedInput-input.Mui-disabled': {
    WebkitTextFillColor: '#000000',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
};

const largeInputStyle = {
  minWidth: 400,
  height: 30,
  fontSize: '13px !important',
  bgcolor: '#ffffff',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '.MuiInputBase-root': {
    fontSize: '13px !important',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& .MuiOutlinedInput-input.Mui-disabled': {
    WebkitTextFillColor: '#000000',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
};

interface Props {
  title?: string | null;
  name: string;
  size?: string;
  type?: string;
  value?: any;
  validate?: boolean;
  maxLength?: number;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
  extendedOnChange?: (event: any) => void;
}

export const InputField: React.FC<Props> = ({
  title,
  name,
  size,
  value,
  validate,
  maxLength,
  disabled,
  type,
  required,
  extendedOnChange,
  ...rest
}) => {
  const { handleChange, setFieldValue } = useFormikContext<any>();

  const zeroCharValidation = (val: any) => {
    let v;
    val === 0 ? (v = '') : (v = val);
    return v.slice(0, maxLength);
  };

  return (
    <div
      className={
        size === 'small' ? styles.smallInputElement : size === 'large' ? styles.largeInputElement : styles.inputElement
      }
    >
      {title && (
        <span className={styles.title}>
          {title}:{required ? <em className={styles.required}>*</em> : null}
        </span>
      )}

      {type !== 'number' ? (
        <OutlinedInput
          defaultValue=""
          autoComplete="off"
          sx={size === 'small' ? smallInputStyle : size === 'large' ? largeInputStyle : inputStyle}
          name={name}
          error={validate && (value === undefined || value === null || value.toString().trim().length === 0)}
          onChange={(event) => {
            if (extendedOnChange) {
              extendedOnChange(event);
            } else {
              handleChange(event);
            }
          }}
          onBlur={(event) => setFieldValue(name, event.target.value.trim())}
          value={value}
          inputProps={{ maxLength }}
          disabled={disabled}
          {...rest}
        />
      ) : (
        <OutlinedInput
          defaultValue=""
          autoComplete="off"
          sx={size === 'small' ? smallInputStyle : size === 'large' ? largeInputStyle : inputStyle}
          name={name}
          error={validate && (value === undefined || value === null || value.toString().trim().length === 0)}
          onChange={(event) => setFieldValue(name, zeroCharValidation(event.target.value))}
          value={value}
          inputProps={{ type, min: 1 }}
          disabled={disabled}
          {...rest}
        />
      )}
    </div>
  );
};
